var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExampleTimeSlots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.807,
    height: 73.723,
    viewBox: "0 0 46.807 73.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26794",
    "data-name": "Group 26794",
    transform: "translate(-11771.784 -2532.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mina_produkter",
    "data-name": "Mina produkter",
    transform: "translate(-1549.979 563.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26735",
    "data-name": "Group 26735",
    transform: "translate(13321.348 1969.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26658",
    "data-name": "Group 26658",
    transform: "translate(9.164 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M0,17.808H0l-.191-.766L0-6.559a4.515,4.515,0,0,1,4.513-4.515H32.595a4.513,4.513,0,0,1,4.513,4.515v62.8a4.513,4.513,0,0,1-4.513,4.513H4.513A4.514,4.514,0,0,1,0,56.236V42.681",
    transform: "translate(0 11.074)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26659",
    "data-name": "Group 26659",
    transform: "translate(19.103 66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M0,0H17.229",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660",
    transform: "translate(22.522 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37305",
    "data-name": "Path 37305",
    d: "M0,0H6.957",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661",
    transform: "translate(32.773 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37306",
    "data-name": "Path 37306",
    d: "M0,0H.14",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Tidsluckor",
    transform: "translate(11772.734 2560.675)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_588",
    "data-name": "Ellipse 588",
    cx: 13.446,
    cy: 13.446,
    rx: 13.446,
    ry: 13.446,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24159",
    "data-name": "Path 24159",
    d: "M351.921,59.928V70.759l7.185,7.185",
    transform: "translate(-338.475 -56.267)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExampleTimeSlots);
export default __webpack_public_path__ + "static/media/Icon_exampleTimeSlots.34c7c0a8af0e1261d3fac98ce778aaee.svg";
export { ForwardRef as ReactComponent };